import { flowRight } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../common/components/runtime-context';
import classNames from 'classnames';
import { ModalFromRight } from '../base';
import ManageCategories from './manage-categories';
import CategorySettings from './category-settings';
import { getCategoryInEditId } from '../../../selectors/categories-manager-selectors';
import { isForumData } from '../../../services/categories-service';
import styles from './categories-manager-modal-component.scss';

class CategoriesManagerModal extends Component {
  closeModal = () =>
    isForumData(this.props.categoryInEditId)
      ? this.props.cancelForumDataChanges(true)
      : this.props.cancelChanges(true);

  render() {
    return (
      <ModalFromRight onClose={this.closeModal} backdropClassName={styles.backdrop}>
        <div className={classNames(styles.container, 'default-forum-card-background-color')}>
          {this.props.categoryInEditId ? (
            <CategorySettings categoryId={this.props.categoryInEditId} />
          ) : (
            <ManageCategories closeModal={this.props.closeModal} />
          )}
        </div>
      </ModalFromRight>
    );
  }
}

CategoriesManagerModal.propTypes = {
  closeModal: PropTypes.func,
  cancelChanges: PropTypes.func,
  cancelForumDataChanges: PropTypes.func,
  categoryInEditId: PropTypes.string,
  modalBackground: PropTypes.string,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  categoryInEditId: getCategoryInEditId(state),
  cancelChanges: actions.categoriesManagerCancelChanges,
  cancelForumDataChanges: actions.categoriesManagerCancelForumDataChanges,
});

export default flowRight(connect(mapRuntimeToProps))(CategoriesManagerModal);
